import { render } from "./lang-select-modal.vue?vue&type=template&id=3559f88d&ts=true"
import script from "./lang-select-modal.vue?vue&type=script&lang=ts"
export * from "./lang-select-modal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__